import { render } from "./MenuApp.vue?vue&type=template&id=4b2c507d"
import script from "./MenuApp.vue?vue&type=script&lang=js"
export * from "./MenuApp.vue?vue&type=script&lang=js"

import "./MenuApp.vue?vue&type=style&index=0&id=4b2c507d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__